module.exports = {
  pleaseWait:"Please wait",
  loading:"loading",
  ID:"ID",
  FAQ:"FAQ",
  TC:"T&C",
  Submit:"Submit",
  change:"Change",
  English:"English",
  Myanmar:"Myanmar",
  Login:"Login",
  Logout:"Log out",
  register:"Register",
  Confirm:"Confirm",
  OK:"OK",
  getCode:"Resend",
  Continue:"Continue",
  language0:"Language",
  language:"Choose Language",
  Copyright:"© 2025 All Rights Reserved.",
  Daily:"Daily",
  Weekly:"Weekly",
  ChancesLeft:"My Points",
  BuyChances:"Buy More Chances",
  BuyChancesC:"You're about to make a one-time purchase.",
  ConfirmPurchase:"Confirm Purchase",
  languageTips:"Choose your language here",
  loginTips:"Enter a phone number",
  profile:"Profile",
  phoneNumber:"Phone Number",
  select:"Select",
  Monthly:"Monthly",
  PhoneNo:"Phone No",
  Level:"Level",
  Rank:"Rank",
  RedeemCenter:"Redeem Center",
  redeemTips1:"browse available items",
  Categories:"Categories",
  ChooseHere:"Choose Here",
  game1T:"AI Training",
  game2T:"Ranked Mode",
  game2T2:"Rank Mode",
  game3T:"Team Mode",
  game4T:"Endless Challenge",
  game1C:"Your smart quiz partner! Improve your Skills!",
  game2C:"Challenge other players in real-time quizzes!",
  game3C:"Challenge your knowledge together with your friends!",
  game4C:"Test your speed and knowledge in endless mode",
  game4C2:"You must answer each question correctly within 10 seconds to continue. The game ends when you select a wrong answer or run out of time.",
  Ranking:"Ranking",
  rankList:"Rank List",
  RedeemList:"Redeem List",
  Settings:"Settings",
  ChooseTitle:"Choose Your Favourite",
  Save:"Save",
  Back:"Back",
  game1Tips1:"Select difficulty levels",
  Easy:"Easy",
  Medium:"Medium",
  Hard:"Hard",
  Matchmaking:"Matchmaking",
  BackToHome:"Back To Home",
  PlayAgain:"Play Again!",
  WaitingTips:"Waiting for friends to join",
  Draw:"Same Score: Draw",
  GameOver:"Game Over",
  CreateRoom:"Create Room",
  JoinRoom:"Join Room",
  RoomID:"Room ID",
  enterRoomID:"Please Enter Room ID",
  EvenlyMatched:"Evenly matched",
  BothPerformedGreat:"Both performed great",
  DominantWin:"Dominant win",
  YouCrushedYourOpponent:"You crushed your opponent",
  KeepUp:"Keep it up",
  SoCloseWinning:"So close to winning",
  MatchingLevel:"Matching range level",
  Waiting:"Waiting",
  Congratulations:"Congratulations, you won",
  SorryLost:"Sorry, you lost",
  YourScore:"Your score",
  OpponentScore:"Opponent's score",
  StartNow:"Start Now!",
  subscribe:'Subscribe',
  notChances:'Not Enough Chances!',
  notChancesTips:"Seems like you're out of chances. You can buy more chances and jump back in!",
  Later:'Later',
  BuyMore:'Buy More',
  Points:'Points',
  Chances:'Chances',
  MemberSince:'Member Since',
  ChanceEnough:'Your Chance is not enough',
  currentLevel:'Your current Level',
  YouCanRedeem:'You can redeem',
  moreTimes:'more times.',
  Redeem:'Redeem',
  congratulations:'CONGRATULATIONS',
  redeemTips:'You are about to redeem',
  NoRedeemRecords:'No one has redeemed now,  please start to play game and redeem now!',
  NoRankList:'No one has points now, please start to play game.',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js